import buildJson from './build.json';

export const build: number = buildJson.Build;
